// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"780feced","966":"b5cb6bf8"}[chunkId] + ".chunk.js";
};